import { render, staticRenderFns } from "./CostComponent.vue?vue&type=template&id=a3c9f26a&"
import script from "./CostComponent.vue?vue&type=script&lang=js&"
export * from "./CostComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports